import axios from 'axios'
import { ENDPOINTS_USER } from './urls'
import { autoReplace, checkError } from 'utils'
import { STATUS_FLAGS } from 'utils/constants/flags'
import { replaceTextKeyByVariablesOfUrl } from 'api/utils'

export const setFullWalkthroughFlag = async (valueFlag) => {
  const url = '/bff-vle/me/walkthrough'
  const { data } = await axios.post(url, { value: valueFlag })
  return data
}

export const setSingleWalkthroughFlag = async (valueFlag) => {
  const url = '/bff-vle/me/singleWalkthrough'
  const { data } = await axios.post(url, { value: valueFlag })
  return data
}

export const login = async ({ licenseCode, password, user }) => {
  const url = '/bff-vle/login'
  const { data } = await axios.post(url, {
    licenseCode,
    password,
    username: user,
  })
  return data
}

export const checkLogin = async () => {
  const { data } = await axios.get(ENDPOINTS_USER.CHECK_LOGIN)
  return data
}

export const getUser = async () => {
  const { data } = await axios.get(ENDPOINTS_USER.ME_DATA)
  return data
}

export const sendLogout = async () => {
  const url = ENDPOINTS_USER.USERS_LOG_OUT
  const { data } = await axios.post(url)
  return data
}

export const checkUserName = async (username) => {
  const url = `/bk/users/checkUsername?username=${username}`
  const { data } = await axios.get(url)
  return data
}

export const checkEmail = async (email) => {
  const correction = {
    [':email']: encodeURIComponent(email),
  }
  const url = autoReplace(ENDPOINTS_USER.CHECK_EMAIL, correction)
  const { data } = await axios.get(url)
  return data
}

export const changePassword = async (newPassword1, newPassword2) => {
  const response = await axios.post(ENDPOINTS_USER.CHANGE_PASSWORD_ME, {
    newPassword1,
    newPassword2,
  })
  return response
}

export const checkPassword = async (data) => {
  const url = '/bk/me/checkPassword'
  const response = await axios.post(url, { password: data })
  return response
}

export const resetPassword = async (userId) => {
  checkError({ userId })
  const correction = {
    [':userId']: userId,
  }
  const url = autoReplace(ENDPOINTS_USER.RESET_PASSWORD, correction)
  const { data } = await axios.post(url)
  return data
}

export const getSchool = async (schoolCode) => {
  const url = `/bk/schools/${schoolCode}`
  const { data } = await axios.get(url)
  return data
}
export const checkSchool = async (schoolId) => {
  const url = ENDPOINTS_USER.CHECK_SCHOOL_ID.replace(':schoolId', schoolId)
  const { data } = await axios.get(url)
  return data
}

export const userCourses = async () => {
  const url = '/bk/me/courses'
  const { data } = await axios.get(url)
  return data
}

export const getUserCourses = async () => {
  const url = ENDPOINTS_USER.ME_COURSES_BFF
  const { data } = await axios.get(url)
  if (data) {
    return data.courses
  } else {
    return data
  }
}

export const userClassrooms = async () => {
  const url = '/bk/me/classrooms'
  const { data } = await axios.get(url)
  return data
}

export const getUserClassrooms = async () => {
  const url = ENDPOINTS_USER.ME_CLASSROOMS_BFF
  const { data } = await axios.get(url)
  return data
}

export const patchUser = async (userData) => {
  const { data } = await axios.patch(ENDPOINTS_USER.ME_DATA, userData)
  return data
}

export const linkGoogleClassroom = async ({ data }) => {
  const url = '/bff-vle/vle/users'
  const response = await axios.post(url, { ...data })
  return response
}

export const unlinkGoogleClassroom = async ({ vleType }) => {
  const url = `/bff-vle/vle/users/${vleType}`
  const response = await axios.delete(url)
  return response
}

export const checkNin = async (nin) => {
  checkError({ nin })
  const url = `/bk/users/checkNIN?nin=${nin}`
  const { data } = await axios.get(url)
  return data
}

export const userSchoolYears = async (userId) => {
  const url = `/bk/users/${userId}/schoolYear`
  const response = await axios.patch(url, {})
  return response
}

export const postLegalConditions = async () => {
  const url = ENDPOINTS_USER.ME_LEGAL_CONDITIONS
  const { data } = await axios.post(url)
  return data
}

export const reSendEmail = async (userId) => {
  const url = `/bk/users/${userId}/resendWelcomeEmail`
  const response = await axios.post(url)
  return response
}

export const postResendEmail = async ({ userId }) => {
  const url = ENDPOINTS_USER.USERS_ID_RESENDWELCOMEEMAIL.replace(
    ':userId',
    userId
  )
  const { data } = await axios.post(url)
  return data
}

export const setSchool = async (code) => {
  const url = `/bk/me/school/${code}`
  const response = await axios.post(url)
  return response
}

export const postAddSchoolToUser = async ({ schoolCode }) => {
  const url = ENDPOINTS_USER.ME_SCHOOL_ID.replace(':schoolCode', schoolCode)
  const { data } = await axios.post(url)
  return data
}

export const postAddSchoolCode = async (schoolId, userId) => {
  const url = replaceTextKeyByVariablesOfUrl({
    replacements: [
      [':schoolId', schoolId],
      [':userId', userId],
    ],
    url: ENDPOINTS_USER.SCHOOL_CODE,
  })

  const { data } = await axios.post(url)
  return data
}

export const setCourse = async (id) => {
  const url = `/bk/me/course/${id}`
  const response = await axios.post(url)
  return response
}

export const postAddCourseToUser = async ({
  courseId,
  isEnabledBff = false,
}) => {
  const baseUrl = isEnabledBff
    ? ENDPOINTS_USER.ME_SET_COURSE
    : ENDPOINTS_USER.ME_COURSE_ID
  const url = baseUrl.replace(':courseId', courseId)
  const { data } = await axios.post(url)
  return data
}

export const setClassroom = async (id) => {
  const url = `/bk/me/classroom/${id}`
  const response = await axios.post(url)
  return response
}

export const postAddClassroomToUser = async ({ classroomId }) => {
  const url = ENDPOINTS_USER.ME_CLASSROOM_ID.replace(
    ':classroomId',
    classroomId
  )
  const { data } = await axios.post(url)
  return data
}

export const setfirstStep = async () => {
  const url = '/bk/me/firstSteps'
  const data = { firstSteps: 'false' }
  const response = await axios.post(url, { ...data })
  return response
}

export const postUserFirstStep = async () => {
  const url = ENDPOINTS_USER.ME_FIRSTSTEPS
  const { data } = await axios.post(url, { firstSteps: STATUS_FLAGS.FALSE })
  return data
}

export const schoolCode = async (schoolCodeId) => {
  const url = `/bk/checkSchool/${schoolCodeId}`
  const response = await axios.get(url)
  return response
}

export const getUserConfigurationsData = async () => {
  const url = ENDPOINTS_USER.ME_CONFIGURATIONS
  const { data } = await axios.get(url)
  return data
}

export const postUserFeedbackPool = async (action) => {
  const url = ENDPOINTS_USER.ME_FEEDBACK_POOL
  const { data } = await axios.post(url, { action })
  return data
}

export const patchUserPromotionTerms = async (userId, value) => {
  const url = ENDPOINTS_USER.USERS_ID_PROMOTIONTERMS.replace(':userId', userId)
  const { data } = await axios.patch(url, { value })
  return data
}

export const recoverPassword = (email) => {
  return axios.post(ENDPOINTS_USER.RECOVER_PASSWORD, {
    email,
  })
}
export const getCheckPasswordSecurity = async (password) => {
  const url = `${ENDPOINTS_USER.CHECK_PASSWORD_SECURITY}?password=${password}`
  const { data } = await axios.get(url)
  return data
}
export const postChangePassword = ({
  newPassword1,
  newPassword2,
  recoverPasswordRequestId,
  userId,
}) => {
  const url = ENDPOINTS_USER.CHANGE_PASSWORD.replace(':userId', userId)
  return axios.post(url, {
    newPassword1,
    newPassword2,
    recoverPasswordRequestId,
  })
}

export const getCheckUserName = async (userName) => {
  const url = `${ENDPOINTS_USER.CHECK_USERNAME}?username=${userName}`
  const { data } = await axios.get(url)
  return data
}

export const unlinkWithGoogle = async (userId) => {
  const correction = {
    [':userId']: encodeURIComponent(userId),
  }
  const url = autoReplace(ENDPOINTS_USER.UNLINK_GOOGLE, correction)
  return axios.delete(url)
}

export const getSystemConfigs = async () => {
  const url = ENDPOINTS_USER.SYSTEM_CONFIGS
  const { data } = await axios.get(url)
  return data
}

export const acceptEdubookLegalConditions = async ({ userId }) => {
  const url = ENDPOINTS_USER.EDUBOOK_LEGAL_CONDITIONS.replace(':userId', userId)
  const { data } = axios.patch(url)
  return data
}

export const acceptPublisherLegalConditions = async ({
  publisherId,
  userId,
}) => {
  const url = replaceTextKeyByVariablesOfUrl({
    replacements: [
      [':userId', userId],
      [':publisherId', publisherId],
    ],
    url: ENDPOINTS_USER.PUBLISHER_LEGAL_CONDITIONS,
  })
  const { data } = axios.post(url)
  return data
}

export const patchPublisherLegalConditions = async ({
  flag,
  publisherId,
  userId,
}) => {
  const url = replaceTextKeyByVariablesOfUrl({
    replacements: [
      [':userId', userId],
      [':publisherId', publisherId],
    ],
    url: ENDPOINTS_USER.PUBLISHER_LEGAL_CONDITIONS,
  })
  const { data } = axios.patch(url, { value: flag })
  return data
}

export const putChangeUserFlag = ({ userFlagName, userId, value }) => {
  const correction = {
    [':userFlagName']: userFlagName,
    [':userId']: userId,
  }
  const url = autoReplace(ENDPOINTS_USER.USER_FLAG, correction)
  return axios.put(url, {
    value,
  })
}
export const getMePublishers = async () => {
  const url = ENDPOINTS_USER.ME_PUBLISHER
  const { data } = await axios.get(url)
  return data
}

export const getTutorIaCourses = async ({ autonomyId }) => {
  const correction = {
    [':autonomyId']: autonomyId,
  }
  const url = autoReplace(ENDPOINTS_USER.TUTOR_IA_AUTONOMY_ID, correction)
  const { data } = await axios.get(url)

  return data
}

export const postTutorIaBookId = async ({ bookId }) => {
  const correction = {
    [':bookId']: bookId,
  }
  const url = autoReplace(ENDPOINTS_USER.TUTOR_IA_BOOK_ID, correction)
  const { data } = await axios.post(url)

  return data
}

export const patchUserPersonalData = async ({ personalData, userId }) => {
  const correction = {
    [':userId']: userId,
  }
  const url = autoReplace(ENDPOINTS_USER.USER_DATA_ID, correction)
  const { data } = await axios.patch(url, personalData)

  return data
}
